import { IWorkLog } from "@wingspanhq/payments/dist/interfaces";
import uniq from "lodash/uniq";
import { useMemo } from "react";
import { useQueryPayeeRows } from "../../../query/search/payee/queries/useQueryPayeeRows";
import { IPayeeRow } from "../../../services/search";

export const usePayeesMap = (workLogs: IWorkLog[] | undefined) => {
  const payeeIds = useMemo(
    () => uniq((workLogs || []).map(workLog => workLog.payeeId)),
    [workLogs]
  );

  const queryPayeeRows = useQueryPayeeRows(
    {
      filter: {
        payeeId: {
          in: payeeIds
        }
      }
    },
    {
      enabled: payeeIds.length > 0
    }
  );

  const payeesMap = useMemo(() => {
    const map = new Map<string, IPayeeRow>();
    (queryPayeeRows.data || []).forEach(payee => {
      map.set(payee.payeeId, payee);
    });
    return map;
  }, [queryPayeeRows.data]);

  return payeesMap;
};
